import React from 'react';
import { useLanguage } from '../lib/i18n';
export function LanguageSwitcher() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="flex items-center gap-1 text-sm" data-id="element-114">
      <button onClick={() => setLang('en')} className={`px-2 py-1 transition-colors ${lang === 'en' ? 'text-white font-medium' : 'text-[#737373] hover:text-[#a3a3a3]'}`} aria-label="Switch to English" data-id="element-115">
        EN
      </button>
      <span className="text-[#737373]" data-id="element-116">|</span>
      <button onClick={() => setLang('cs')} className={`px-2 py-1 transition-colors ${lang === 'cs' ? 'text-white font-medium' : 'text-[#737373] hover:text-[#a3a3a3]'}`} aria-label="Přepnout na češtinu" data-id="element-117">
        CZ
      </button>
    </div>;
}